import { type MouseEvent, useCallback } from 'react';

export const useCardFlashlightHoverHandlers = () => {
  const onMouseMove = useCallback((mouseEvent: MouseEvent<HTMLDivElement>) => {
    const element = mouseEvent.currentTarget;
    const rect = element.getBoundingClientRect();

    const x = ((mouseEvent.clientX - rect.left) / rect.width) * 100;
    const y = ((mouseEvent.clientY - rect.top) / rect.height) * 100;

    const clampedX = Math.max(0, Math.min(100, x));
    const clampedY = Math.max(0, Math.min(100, y));

    element.style.setProperty('--flashlight-x', `${clampedX}%`);
    element.style.setProperty('--flashlight-y', `${clampedY}%`);
  }, []);

  const onMouseLeave = useCallback((mouseEvent: MouseEvent<HTMLDivElement>) => {
    const element = mouseEvent.currentTarget;
    element.style.removeProperty('--flashlight-x');
    element.style.removeProperty('--flashlight-y');
  }, []);

  return { onMouseMove, onMouseLeave };
};

export const useMergedHandlers = (
  defaultHandler: (event: MouseEvent<HTMLDivElement>) => void,
  customHandler?: (event: MouseEvent<HTMLDivElement>) => void
) => {
  return (event: MouseEvent<HTMLDivElement>) => {
    defaultHandler(event);
    if (customHandler) {
      customHandler(event);
    }
  };
};
